package com.essntl.features.currency.data.repository

import com.essntl.core.supabase.getAll
import com.essntl.core.supabase.getOne
import com.essntl.core.utils.repository.Repository
import com.essntl.features.currency.data.supabase.CurrencySupabaseDataSource
import com.essntl.features.currency.domain.model.CurrencyModel
import com.essntl.features.currency.domain.repository.CurrencyRepository
import io.github.jan.supabase.postgrest.query.Order
import org.koin.core.annotation.Single

@Single(binds = [CurrencyRepository::class])
class CurrencyRepositoryImpl(
    private val supabase: CurrencySupabaseDataSource,
) : CurrencyRepository, Repository() {

    override suspend fun getAll(): Result<List<CurrencyModel>> =
        runCatching {
            supabase
                .getAll { filter { } }
                .map { it.toModel() }
        }

    override suspend fun getByCode(code: String): Result<CurrencyModel> =
        runCatching {
            supabase
                .getAll {
                    filter {
                        eq("code", code)
                    }
                }.first().toModel()
        }
}
